import { useEffect, useState } from "react";
import { Table, Card, Input, Pagination, message, Button, Modal } from 'antd';
import axios from "axios";
import { BarsOutlined } from "@ant-design/icons";
import dayjs from "dayjs";


const ApplicationJobs = () => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const [applicationJobs, setApplicationJobs] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [detailData, setDetailData] = useState();
    const [openDetail, setOpenDetail] = useState();
    const [sortJobs, setSortJobs] = useState();
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [total, setTotal] = useState(0);

    const fieldLabels = {
        job: "Job Name",
        name: "Name",
        phone: "Phone",
        email: "Email",
        resume: "Resume",
        coverLetter: "Cover Letter",
        created_at: 'Created At',
    };

    //supaya modal detail menampilkan sesuai urut yg gue mau wkwk
    const detailOrder = [
        "job",
        "name",
        "phone",
        "email",
        "resume",
        "coverLetter",
        "created_at",
    ];

    const FetchApplicationJobs = async (pageNumber = 1, searchText = "", sortJobs = "desc") => {
        setLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/api/application_jobs`, {
                params: {
                    page: pageNumber,
                    limit,
                    search: searchText || "",
                    sort: "title",
                    order: sortJobs?.toUpperCase() || "DESC"
                }
            });
            console.log('FetchApplication response:', res);
            setApplicationJobs(res.data?.data?.rows || []);
            setTotal(res.data?.data?.count || 0);
        } catch (error) {
            console.error('FetchApplication error:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchJobs = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/api/jobs`, {
                params: { search: searchText, page: pageNumber, limit }
            });
            setJobs(res.data.data || []);
            setTotal(res.data.total || 0);
            setPage(pageNumber);
        } catch {
            message.error('Failed to fetch jobs');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        FetchApplicationJobs(page, searchText, sortJobs || "desc");

    }, [page, searchText, sortJobs]);

    useEffect(() => {
        fetchJobs(1);

    }, [searchText]);


    const columns = [
        {
            title: "No",
            render: (_, __, index) => (page - 1) * limit + index + 1,
        },
        {
            title: 'Jobs Name',
            dataIndex: ['job', 'title'], // nested access
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: (column) => ({
                onClick: () => {
                    const newSort = sortJobs === 'asc' ? 'desc' : 'asc';
                    setSortJobs(newSort);
                }
            }),
            render: (text) => text || "-"

        },
        { title: 'Name', dataIndex: 'name' },
        {
            title: 'Resume',
            dataIndex: 'resume',
            render: (filePath) => {
                if (!filePath) return "-";
                return (
                    <a href={`${BASE_URL}${filePath}`} target="_blank" rel="noopener noreferrer">
                        Download PDF
                    </a>
                );
            }
        },
        {
            title: 'Actions',
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Button
                        style={{
                            borderColor: '#ec4899',
                            color: '#ec4899',
                            marginRight: 8,
                        }}
                        icon={<BarsOutlined />}
                        type="link"
                        onClick={() => {
                            setDetailData({
                                ...record,
                            });
                            setOpenDetail(true);
                        }} />

                </div>
            ),
        },
    ];

    return (
        <Card title='Application Jobs'>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Input.Search
                    placeholder="Search Application Jobs.."
                    allowClear
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ width: 300 }}
                />
            </div>

            <Table
                columns={columns}
                dataSource={applicationJobs}
                rowKey="id"
                loading={loading}
                pagination={false}
                style={{ marginTop: 20 }}
            />

            <Pagination
                current={page}
                pageSize={limit}
                total={total}
                onChange={(page) => setPage(page)}
                style={{ marginTop: 16, textAlign: 'right' }}
            />

            <Modal
                title="Application Jobs Detail"
                open={openDetail}
                onCancel={() => setOpenDetail(false)}
                footer={[
                    <Button
                        key="close"
                        style={{
                            backgroundColor: '#ec4899',
                            borderColor: '#ec4899',
                            color: '#fff',
                            marginRight: 8,
                        }}

                        onClick={() => setOpenDetail(false)}>
                        Close
                    </Button>
                ]}
            >
                {detailData && (
                    <Table
                        dataSource={detailOrder.map((key) => {
                            let value = detailData[key];

                            if (key === "job" && value?.title) {
                                value = value.title;
                            } else if (key === "resume" && value) {
                                value = (
                                    <a
                                        href={`${BASE_URL}${value}`}
                                        target="_blank"
                                        rel="nooper noreferrer"
                                    >
                                        Download PDF
                                    </a>
                                );
                            } else if (!value) {
                                value = "-";
                            }

                            if (key === "created_at" && value) {
                                value = dayjs(value).format("YYYY-MM-DD HH:mm:ss");
                            }

                            return {
                                key,
                                field: fieldLabels[key] || key,
                                value
                            };
                        })}
                        columns={[
                            {
                                title: 'Field',
                                dataIndex: 'field',
                                key: 'field',
                                width: '30%',
                                render: text => <strong>{text}</strong>,
                            },
                            {
                                title: 'Value',
                                dataIndex: 'value',
                                key: 'value',
                            },
                        ]}
                        pagination={false}
                        bordered
                    />
                )}
            </Modal>
        </Card>
    );
};

export default ApplicationJobs;